// src/database/index.ts
import { Platform } from 'react-native';
import { Database } from '@nozbe/watermelondb';

import { schemas } from './schema';
import { migrations } from './migrations';
import { User }    from './models/User';

// ➜ Seleciona o adapter certo para cada plataforma
let adapter: any;

if (Platform.OS === 'web') {
  // Usa IndexedDB (via LokiJS) no navegador
  const LokiJSAdapter =
    require('@nozbe/watermelondb/adapters/lokijs').default;

  adapter = new LokiJSAdapter({
    schema: schemas,
    migrations,
    useIncrementalIndexedDB: false,
    useWebWorker: false,   // simples; ligue se quiser
  });
} else {
  // iOS / Android seguem com SQLite nativo
  const SQLiteAdapter =
    require('@nozbe/watermelondb/adapters/sqlite').default;

  adapter = new SQLiteAdapter({
    schema: schemas,
    migrations,
    // outras opções nativas (migrations, onSetUpError…) se precisar
  });
}

export const database = new Database({
  adapter,
  modelClasses: [User],
});
